import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  errorMessage: "",
};

const errorsSlice = createSlice({
  name: "errors",
  initialState,
  reducers: {
    setErrorMessage(state, action) {
      state.errorMessage = action.payload;
    },
  },
});

export const { setErrorMessage } = errorsSlice.actions;

export default errorsSlice.reducer;
